<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <loader *ngIf="showLoader"></loader>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-20">
                        <h6 class="content-header-title float-left mb-0 ml-10" style="color: black">My Account</h6>
                    </div>
                    <div class="col-md-6 text-right">
                        <button  class="btn btn-primary" (click)="goToEditProfile()">
                            Edit Profile
                        </button>
                        <button *ngIf="!isVcipComplete" type="submit" style="margin-left: 15px;" rippleEffect class="btn btn-primary fs-10"
                            (click)="openModalForVCIPNewUser()">
                            Please Complete VCIP
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <a class="mr-25" *ngIf="consumerDetail?.photo != null && consumerDetail?.photo != '' ">
                            <img src="{{consumerDetail?.photo}}" class="b-radius50" height="70" width="70"
                                style="border: 3px solid #234;" />
                        </a>
                        <a class="mr-25" *ngIf="consumerDetail?.photo == null || consumerDetail?.photo == '' ">
                            <img src="assets/images/avatars/user.png" class="b-radius50 mr-50" height="70" width="70" />
                        </a>
                        <div class="text-black fs-12 fw-600 mt-10" style="border-color:black">
                            {{this.consumerDetail?.paxResponse?.name}}</div>
                        <div class="text-black20 fs-11" style="color: black">
                            {{this.consumerDetail?.paxResponse?.mobile}}</div>
                        <div class="text-black fs-11 mt-10" *ngIf="resGetVcipStatus?.vcipStatus">
                            Video KYC Status: <span class="fw-600"
                                [style.color]="resGetVcipStatus?.vcipStatus == 'ACCEPTED' ? '#28a745' : (resGetVcipStatus?.vcipStatus == 'PENDING' ? '#fd7e14' : '#dc3545')">{{ resGetVcipStatus?.vcipStatus }}</span></div>
                    </div>
                </div>

                <div class="row mt-30">
                    <div class="col-md-2" *ngFor="let singleItem of menuItems" (mouseover)="singleItem.iconSrc = singleItem.iconW" (mouseout)="singleItem.iconSrc = singleItem.icon">
                        <div class="card cursor account-menu-item-box" (click)="proceedToNextPage(singleItem.url)">
                            <div class="card-body text-center">
                                <img src="assets/images/profile/{{singleItem.iconSrc}}" style="width:40px;height:40px">
                                <div class="fs-10 fw-600 mt-10"> {{ singleItem.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- xplorer popup -->
<ng-template let-modal #vcipModalNewUser>
    <div class="modal-header" *ngIf="xplorerVcipTitle">
        <h6 class="modal-title w-100 text-center fw-bold" style="color: #1d2a62;">{{ xplorerVcipTitle }}</h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col-md-12">
            <div class="text-center text-black fw-500 mt-10 mb-10 fs-14" style="color: black">
                {{ xplorerVcipMessage || 'VCIP (Video KYC in Person) is mandatory and must be completed at the verified address before your travel. Completing this early ensures smooth usage of your card abroad.' }}
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row w-100 justify-content-center">
            <button class="btn vcip-btn vcip-okay-btn" rippleEffect (click)="onVcipModalAction()">
                {{ getXplorerVcipActionLabel() }}
            </button>
        </div>
    </div>
</ng-template>
